"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Box_1 = __importDefault(require("../../layouts/Box"));
const Stack_1 = __importDefault(require("../../layouts/Stack"));
const Heading_1 = __importDefault(require("../../components/Heading"));
const useStyles = styles_1.makeStyles({
    root: {
        textAlign: 'center',
        width: 'fit-content',
        padding: '10px',
    },
});
const withNorthStarBaseChart = (ChartComponent) => (props) => {
    const classes = useStyles();
    return (react_1.default.createElement(Box_1.default, { className: classes.root },
        react_1.default.createElement(Stack_1.default, null,
            props.title && react_1.default.createElement(Heading_1.default, { variant: "h3" }, props.title),
            react_1.default.createElement(ChartComponent, Object.assign({}, props)))));
};
exports.default = withNorthStarBaseChart;
//# sourceMappingURL=index.js.map